import { CommonModule } from '@angular/common';
import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { readMemberProfileFromStorage } from '../../services/member-auth';
import {environment} from '../../../environments/environments';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  memberName = 'Member';
  memberCode = '';
  memberPhoto: string | null = null;
  isDropdownOpen = false;

  constructor(private router: Router, private elementRef: ElementRef) { }

  ngOnInit(): void {
    if (typeof window === 'undefined') return;
    const profile = readMemberProfileFromStorage();
    this.memberName = profile.memberName || 'Member';
    this.memberCode = (profile.memberCode || '').toUpperCase();
    const photo = profile.memberPhoto;
    this.memberPhoto = this.normalizePhotoUrl(photo ?? null);
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (
      this.isDropdownOpen &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.isDropdownOpen = false;
    }
  }

  onMemberPhotoError(): void {
    this.memberPhoto = null;
  }

  private normalizePhotoUrl(photo: string | null): string | null {
    let value = (photo ?? '').trim();
    if (!value || value === 'null' || value === 'undefined') return null;
    // Handle accidentally quoted values: "https://...".
    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1).trim();
    }
    // Handle escaped values from serialized payloads.
    value = value.replace(/\\\//g, '/').trim();
    if (!value.startsWith('http')) return null;
    return value;
  }

  logout() {
    this.router.navigate(['/sign-in']);
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }

  navigateToProfile() {
    this.isDropdownOpen = false;
    this.router.navigate(['/member_directory/my-profile']);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  signOut(): void {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
    this.isDropdownOpen = false;
    void this.router.navigate(['/sign-in']);
  }

  redirectModule() {
    window.location.href = environment.loginUrl + 'module';
  }
}